module.exports = function getResource(label, vars = []) {
    const resources = { remove: 'Supprimer' };
    return resources[label];
};
